import React from "react";
import { secondaryColor, bgColorOppositeShade } from "../../utils/constants";

export default function AddTPButton({ color = secondaryColor, color2 = bgColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.24 20.24">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <circle fill={color} cx="10.12" cy="10.12" r="10.12" />
          <path
            fill={color2}
            d="M10.12,15.1a.7.7,0,0,1-.71-.71V5.84a.71.71,0,1,1,1.42,0v8.55A.71.71,0,0,1,10.12,15.1Z"
          />
          <path fill={color2} d="M14.39,10.83H5.84a.71.71,0,1,1,0-1.42h8.55a.71.71,0,1,1,0,1.42Z" />
        </g>
      </g>
    </svg>
  );
}
